import type { ReactNode } from 'react';
import { memo } from 'react';
import { QuickSearchDataProvider } from '../../quick-search/contexts/QuickSearchDataContext';
import { QuickSearchStateContextProvider } from './QuickSearchStateContext';
import { SearchHistoryProvider } from './SearchHistoryContext';

export const SearchContextProvider = memo(
  ({ children }: { children: ReactNode }) => {
    return (
      <QuickSearchStateContextProvider>
        <SearchHistoryProvider>
          <QuickSearchDataProvider>{children}</QuickSearchDataProvider>
        </SearchHistoryProvider>
      </QuickSearchStateContextProvider>
    );
  }
);
